<template>
  <div class="pa-3 ma-3">
    <v-alert-dialog ref="alert"></v-alert-dialog>

    <!-- ADD / EDIT -->
    <v-dialog max-width="65%" v-model="dialogAddEdit" persistent>
      <v-card>
        <v-card-title>
          {{ editedItem.id_pago_forma === null ? "Crear" : "Editar" }} Forma de
          Pago
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="editedItem.nombre"
                label="Forma de Pago"
                outlined
                dense
                hide-details
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="editedItem.id_titular_cuenta"
                :items="titularesCuenta"
                item-value="id"
                item-text="nombre"
                label="Titular de la Cuenta"
                outlined
                dense
                hide-details
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="editedItem.clave_sat"
                label="Clave según SAT"
                outlined
                dense
                hide-details
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="green" text @click="closeDialogAddEdit">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogAddEdit" :loading="loadingSave">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DELETE -->
    <v-dialog max-width="65%" v-model="dialogDelete" persistent>
      <v-card>
        <v-card-title>Eliminar Forma de Pago</v-card-title>

        <v-card-text>
          ¿Está seguro de que desea eliminar la forma de pago "{{
            editedItem.nombre
          }}" con titular "{{ editedItem.nombre_titular_cuenta }}"? Esta acción es
          permanente y no se puede revertir.
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="green" text @click="closeDialogDelete">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogDelete" :loading="loadingDelete">
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--
    <v-row>
      <v-col cols="12">
        <v-btn color="primary" @click="openDialogAddEdit(null)">
          Crear Forma de Pago
        </v-btn>
      </v-col>
    </v-row>
    -->

    <v-row>
      <v-col cols="12">
        <v-data-table :items="items" :headers="headers" :loading="loading">
          <!--
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="openDialogAddEdit(item)">
              mdi-pencil
            </v-icon>
            <v-icon small class="mr-2" @click="openDialogDelete(item)">
              mdi-delete
            </v-icon>
          </template>
          -->
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import VAlertDialog from "@/components/VAlertDialog.vue";

export default {
  components: {
    VAlertDialog,
  },

  data: () => ({
    dialogAddEdit: false,
    dialogDelete: false,

    loading: false,
    loadingSave: false,
    loadingDelete: false,

    items: [],
    headers: [
      { text: "Forma de Pago", value: "nombre", align: "center", width: "30%" },
      {
        text: "Titular de la Cuenta",
        value: "nombre_titular_cuenta",
        align: "center",
        width: "40%",
      },
      { text: "Clave según SAT", value: "clave_sat", align: "center", width: "20%" },
      { text: "Acciones", value: "actions", align: "center", width: "10%" },
    ],

    // Si esto viene de API en tu sistema, puedes reemplazarlo por un get.
    titularesCuenta: [
      { id: 1, nombre: "No aplica" },
      { id: 2, nombre: "Un Buen Grupo de Amigos" },
      { id: 3, nombre: "Trabajador UBGA autorizado" },
    ],

    editedItem: {
      id_pago_forma: null,
      nombre: "",
      id_titular_cuenta: null,
      nombre_titular_cuenta: "",
      clave_sat: "",
    },

    defaultEditedItem: {
      id_pago_forma: null,
      nombre: "",
      id_titular_cuenta: null,
      nombre_titular_cuenta: "",
      clave_sat: "",
    },
  }),

  mounted() {
    this.getItems();
  },

  methods: {
    getItems() {
      this.loading = true;
      axios
        .get("/Pagos/ListarPagoFormas")
        .then((response) => {
          this.items = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    saveDialogAddEdit() {
      // Validaciones
      if (
        this.editedItem.nombre == null ||
        this.editedItem.nombre.length === 0 ||
        this.editedItem.nombre.length > 100
      ) {
        this.$refs.alert.setMessage(
          "",
          "Debe ingresar una Forma de Pago entre 1 y 100 caracteres"
        );
        this.$refs.alert.open();
        return;
      }

      if (this.editedItem.id_titular_cuenta == null) {
        this.$refs.alert.setMessage("", "Debe seleccionar un Titular de la Cuenta");
        this.$refs.alert.open();
        return;
      }

      if (
        this.editedItem.clave_sat == null ||
        this.editedItem.clave_sat.length === 0 ||
        this.editedItem.clave_sat.length > 10
      ) {
        this.$refs.alert.setMessage(
          "",
          "Debe ingresar una Clave SAT entre 1 y 10 caracteres"
        );
        this.$refs.alert.open();
        return;
      }

      this.saveDialogAddEditAPI();
    },

    saveDialogAddEditAPI() {
      this.loadingSave = true;

      axios({
        method: this.editedItem.id_pago_forma === null ? "POST" : "PUT",
        url:
          this.editedItem.id_pago_forma === null
            ? "/Pagos/CrearPagoForma"
            : `/Pagos/EditarPagoForma/${this.editedItem.id_pago_forma}`,
        data: {
          nombre: this.editedItem.nombre,
          id_titular_cuenta: this.editedItem.id_titular_cuenta,
          clave_sat: this.editedItem.clave_sat,
        },
      })
        .then(() => {
          this.getItems();
          this.closeDialogAddEdit();
        })
        .catch((error) => {
          if (error.response && error.response.status == 409) {
            this.$refs.alert.setMessage(
              "",
              "Ya existe una Forma de Pago con los mismos datos."
            );
            this.$refs.alert.open();
            return;
          }
          console.log(error);
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },

    saveDialogDelete() {
      this.loadingDelete = true;
      axios
        .delete(`/Pagos/EliminarPagoForma/${this.editedItem.id_pago_forma}`)
        .then(() => {
          this.closeDialogDelete();
          this.getItems();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingDelete = false;
        });
    },

    // ========== UI ==========
    openDialogAddEdit(editItem = null) {
      this.editedItem = editItem
        ? Object.assign({}, editItem)
        : Object.assign({}, this.defaultEditedItem);

      // si la API no manda nombre_titular_cuenta pero sí id_titular_cuenta, lo derivamos:
      if (
        this.editedItem.id_titular_cuenta != null &&
        (!this.editedItem.nombre_titular_cuenta ||
          this.editedItem.nombre_titular_cuenta.length === 0)
      ) {
        const t = this.titularesCuenta.find((x) => x.id === this.editedItem.id_titular_cuenta);
        if (t) this.editedItem.nombre_titular_cuenta = t.nombre;
      }

      this.dialogAddEdit = true;
    },

    closeDialogAddEdit() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogAddEdit = false;
    },

    openDialogDelete(editItem) {
      this.editedItem = Object.assign({}, editItem);

      // fallback por si solo viene id_titular_cuenta
      if (
        this.editedItem.id_titular_cuenta != null &&
        (!this.editedItem.nombre_titular_cuenta ||
          this.editedItem.nombre_titular_cuenta.length === 0)
      ) {
        const t = this.titularesCuenta.find((x) => x.id === this.editedItem.id_titular_cuenta);
        if (t) this.editedItem.nombre_titular_cuenta = t.nombre;
      }

      this.dialogDelete = true;
    },

    closeDialogDelete() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogDelete = false;
    },
  },
};
</script>
